/**
 * @Author: shenyi
 * @Date:   2024-01-15 17:46:11
 * @Last Modified by:   shenyi
 * @Last Modified time: 2024-01-16 10:35:02
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    redirect: "/login",
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/login.vue")
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/register.vue")
  },
  {
    path: "/forgotPassword",
    name: "ForgotPassword",
    component: () => import("../views/forgotPassword.vue")
  },

  {
    path: "/personal",
    name: "PersonalMessage",
    component: () => import("../views/personalMessage.vue"),
  },
  {
    path: "/success",
    name: "SubmitSuccess",
    component: () => import("../views/submitSuccess.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base:
    process.env.NODE_ENV === "production"
      ? "/fe-pc/b/fe_shiyan_baoming_guoji"
      : "/",
  routes,
});

export default router;
